import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import {Field} from "./index.styles";
import _ from "lodash";

const IdDetailsSkeleton = () => {
  return (
    <>
      {_.times(3, (index) => (
        <Field key={index}>
          <span className="title">
            <Skeleton width={80} />
          </span>
          <span className="value">
            <Skeleton />
          </span>
        </Field>
      ))}
    </>
  );
};

export default IdDetailsSkeleton;
